// extracted by mini-css-extract-plugin
export default {"error_text":"registrationPage_error_text__DwtUB"};